import {FieldProps} from "formik";
import _ from "lodash";
import * as React from "react";
import {useCallback} from "react";
import {IInputFieldProps} from "@/models/form-controls.model";
import {Input} from "@/components/ui/input";
import {inputVariants} from "@/constants/animations.ts";
import {motion} from "framer-motion";

interface FormikInputComponentProps extends IInputFieldProps {
    formikField: FieldProps;
    fullWidth?: boolean;
}

const FormInput = (props: FormikInputComponentProps) => {
    const {
        formikField,
        onChange,
        label,
        type = "text",
        placeholder,
        icon,
        ...otherProps
    } = props;

    const {field, form} = formikField;
    const {name, value} = field;
    const {setFieldTouched, touched, errors, setFieldValue} = form;
    const hasError = _.get(touched, name) && !!(_.get(errors, name));

    const textChangeHandler = useCallback((text: string) => {
        setFieldValue(name, text);
        setFieldTouched(name);
        if (onChange) {
            onChange(text);
        }
    }, [setFieldValue, setFieldTouched, name, onChange]);


    return (
        <motion.div variants={inputVariants}
                    initial="initial"
                    animate="animate">
            <Input
                type={type}
                placeholder={placeholder}
                icon={icon}
                fullWidth={true}
                onChange={textChangeHandler}
                label={label}
                hasError={hasError}
                value={value}
                errorMessage={hasError && (_.get(errors, name))}
                // onBlur={onInputBlur}
                // onFocus={handleOnBlur}
                {...otherProps}
            />
        </motion.div>
    );
};

export default FormInput;
